export class Task { 
        additional_files: any
        additional_files_details: any
        assigned_to: any
        assigned_to_details:any
        assigned_to_group:any
        assigned_to_group_details: any
        completed_at:string
        cost_approval:boolean
        project_client_id:number
        project_cost:number
        created_at:string
        created_by:string
        description:string
        due_date:string
        github_pr_url:string
        id:number
        is_upcoming_release:false
        modified_at:string
        modified_by:number
        name:string
        is_reviewed:boolean
        priority:number
        progress:number
        project_client_name:string
        project_name:string
        rejection_reason:string
        task_project:number
        task_status:number
        task_status_name:string
}

export class TaskResponseModel {
    count:number
    next:string
    previous:string
    results: Task[]
    initialValue?:any
  }

export class TaskStatus {
    id:number
    name:string
    hexColor:string
}

export class TaskStatusResponseNodel{
    count:number
    next:string
    previous:string
    results: TaskStatus[]
}

export class UserGroupResponseModel{
    count:number
    next:string
    previous:string
    results: UserGroup[]
}


export class Timezone {
    id:number
    name:string
    offset:number
    slug:string
}

export class TimezonResponseModel{
    count:number
    next:string
    previous:string
    results: Timezone[]
}


export class UserGroup{
    id:number 
    user_detail:[]
    created_at:string	 
    modified_at	:string 
    name :string
    created_by:string 
    modified_by:number 
    is_customer_ops:boolean
    is_event_ops:boolean
    user:[]
}

export class UserResponseModel{
    count:number
    next:string
    previous:string
    results: User[]
}

export class PriorityResponseModel{
    count:number
    next:string
    previous:string
    results: Priority[]
}

export class  Priority{
    id:number
    name:string
}  


export class User{
    id:number	 
    user_name:string
    email:string
    middlename:string
    type:string
    job_title:string
    photo_url:string
    provider:string
    is_deleted:boolean
    name:string
    auth_user:number
    group:number[]
    permissions:number[]
}

export class TaskComment {
    id:number
    task_name:string
    created_by_name:string
    modified_by_name:string
    created_at:string
    modified_at:string
    comment:string
    created_by:number
    modified_by:number
    source_task:string

}

export class TaskCommentResponseModal {
    count:number
    next:string
    previous:string
    results: TaskComment[]
}

export class TaskFilter {
    id:number
    project_name:string
    assigned_to:number
    assigned_to_group:number
    task_status:number
    priority:number
    due_date:string
    status:string
}